var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',[_c('TermsConditions' + (_vm.language ? _vm.language.toUpperCase() : 'EN'),{tag:"component"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }